import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { loadStripe } from '@stripe/stripe-js';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription
} from './ui/dialog';
import coinImg from '../resources/Sheaf_2.png';
import { createCheckoutSession } from '../Services/SheafService';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const SheafButton = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [isOpen, setIsOpen] = useState(false);
  const [amount, setAmount] = useState('');

  const handleCheckout = async () => {
    const parsed = parseFloat(amount);
    if (isNaN(parsed) || parsed <= 0) return;
    try {
      const token = await getAccessTokenSilently({
        authorizationParams: { audience: process.env.REACT_APP_API_AUDIENCE },
      });
      const { sessionId } = await createCheckoutSession(token, parsed);
      const stripe = await stripePromise;
      await stripe.redirectToCheckout({ sessionId });
    } catch (err) {
      console.error('Error purchasing Sheaf:', err);
    }
  };

  return (
    <>
      <Button
        variant="secondary"
        // onClick={() => setIsOpen(true)}
        className="flex items-center space-x-1"
      >
        <img src={coinImg} alt="Sheaf" className="w-4 h-4" />
        <span>TYK Sheaf</span>
      </Button>
      <Dialog isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <DialogHeader>
          <DialogTitle>Purchase Sheaf</DialogTitle>
          <DialogDescription>
            Sheaf is a token that complements the bartering system by allowing
            users to add tokens to a trade and balance perceived inequalities.
          </DialogDescription>
        </DialogHeader>
        <DialogContent>
          <div className="space-y-2">
            <Label htmlFor="sheaf-amount">Amount to purchase</Label>
            <Input
              id="sheaf-amount"
              type="number"
              min="1"
              step="1"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogFooter>
          <Button variant="secondary" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button onClick={handleCheckout}>Continue</Button>
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default SheafButton;
